@let showNavigation = this.showNavigation();
<!-- Shell chrome: the sidebar is NOT a route. It must survive navigation, and
     it must not appear on login, where there is nothing to navigate to and
     nobody to sign out.

     ONE piece of chrome, not two (2026-08-29). A top bar briefly lived here
     holding an app name and a sign-out button; both belong in the sidebar,
     Juno has no top bar, and these are dense data screens that want the
     vertical space. Sign out now sits in the sidebar footer. -->
<div class="app-shell">
  @if (showNavigation) {
    <app-sidebar />
  }
  <main class="app-content">
    <router-outlet />
  </main>
</div>
